"use client";
import React from "react";
import { SectionHeading } from "@/components/common/decor";

const books = [
  { img: "/images/Item-2.webp", title: "The Wounded Roar", author: "Ansumana A. Kosha", tag: "100,000+ Copies Sold" },
  { img: "/images/Item-1.webp", title: "Death and Breakfast", author: "Angelique Devereaux", tag: "Six-Figure Deal · WSJ Bestseller" },
  { img: "/images/Item-3.webp", title: "The Clockmaker's Mystery", author: "Romans 8:17", tag: "#1 B&N and WSJ Bestseller" },
  { img: "/images/Item-6.webp", title: "Johnn Angel", author: "Alfred J Grall", tag: "100,000+ Copies Sold" },
  { img: "/images/Item-8.webp", title: "The Cliché Chronicles", author: "Brian S. Bradley", tag: "#1 International Bestseller" },
];

export default function Bestsellers() {
  return (
    <section className="relative overflow-hidden bg-ink px-4 py-20 text-white md:px-8">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-brand-500/20 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-gold/10 blur-3xl"
      />
      <div className="relative mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="Proven Results"
          title="Real Authors. Real Books. Real Shelves."
          description="A look at the bestsellers, award-winners, and reader favorites we've helped bring to market."
          light
          className="mb-14"
        />

        <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-5">
          {books.map((b, i) => (
            <div
              key={b.title}
              data-aos="fade-up"
              data-aos-delay={i * 80}
              className="group"
            >
              <div className="relative overflow-hidden rounded-2xl ring-1 ring-white/10 transition-all duration-500 group-hover:-translate-y-2 group-hover:ring-gold/50">
                <img loading="lazy" decoding="async" src={b.img} alt={b.title} className="aspect-[3/4] w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              </div>
              <p className="mt-3 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-gold-soft">
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-gold" />
                {b.tag}
              </p>
              <h3 className="mt-1 font-display text-base font-semibold leading-snug text-white">{b.title}</h3>
              <p className="text-xs text-white/60">{b.author}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
